export default __webpack_public_path__ + "static/media/afr_mobile_2.a49c9be7.png";